/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import React from 'react';
// material
import { Link } from '@insticator/insticator-ui'; // iui-material



/* ========== ~~~~~~~~~~ CTA : BACK TO EMBEDS ~~~~~~~~~~ ========== */
const BackToEmbedsCTA = (props) => {
	return (
		<div>
            <Link
                name={`backtoembeds`}
                type={`internal`}
                behavior={`back`}
                text={`Back to all embeds`}
                color={`primary`}
                action={`dashboard/embeds`}
                icon={`hand-point-left`}
            />
		</div>
	);
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default BackToEmbedsCTA;
